import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/Table/settings/DataTab';
import { ViewTab } from 'modules/visualisations/Table/settings/ViewTab';

export const TableMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
